/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AttemptGrantDto } from '../models';
// @ts-ignore
import type { AttemptLockDto } from '../models';
// @ts-ignore
import type { AttemptReasonDto } from '../models';
// @ts-ignore
import type { AttemptStandingDto } from '../models';
// @ts-ignore
import type { ConflictProblemDto } from '../models';
// @ts-ignore
import type { ProblemDetailDto } from '../models';
/**
 * TestPeopleApi - axios parameter creator
 * @export
 */
export const TestPeopleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * How many attempts count and how many were invalidated, the limit with the attempts granted on top of it, what is left, a pass, and a lock — what decides whether the next attempt starts. Known by the SAP number alone: the person need not have taken the test.
         * @summary Where a person stands with a test
         * @param {string} testId 
         * @param {string} sapNumber The person, by the SAP number.
         * @param {string} [positionCode] The position the person would take the test for; the limit follows it. Absent for the test\&#39;s own limit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestPerson: async (testId: string, sapNumber: string, positionCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('getTestPerson', 'testId', testId)
            // verify required parameter 'sapNumber' is not null or undefined
            assertParamExists('getTestPerson', 'sapNumber', sapNumber)
            const localVarPath = `/api/v1/tests/{testId}/people/{sapNumber}`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)))
                .replace(`{${"sapNumber"}}`, encodeURIComponent(String(sapNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (positionCode !== undefined) {
                localVarQueryParameter['positionCode'] = positionCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Always with a reason. Each grant raises the person\'s limit at the test by one; it does not lift a lock, nor the rule of a test that takes no attempt after a pass. Granted by an administrator for now; who else may, comes with permissions.
         * @summary Grant the person one attempt more than the limit
         * @param {string} testId 
         * @param {string} sapNumber The person, by the SAP number.
         * @param {AttemptReasonDto} attemptReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantAttempt: async (testId: string, sapNumber: string, attemptReasonDto: AttemptReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('grantAttempt', 'testId', testId)
            // verify required parameter 'sapNumber' is not null or undefined
            assertParamExists('grantAttempt', 'sapNumber', sapNumber)
            // verify required parameter 'attemptReasonDto' is not null or undefined
            assertParamExists('grantAttempt', 'attemptReasonDto', attemptReasonDto)
            const localVarPath = `/api/v1/tests/{testId}/people/{sapNumber}/grants`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)))
                .replace(`{${"sapNumber"}}`, encodeURIComponent(String(sapNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attemptReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * With a reason. While the lock is in force no attempt of the person at the test starts; an attempt already running goes on — invalidating ends it.
         * @summary Lock the person\'s attempts at the test
         * @param {string} testId 
         * @param {string} sapNumber The person, by the SAP number.
         * @param {AttemptReasonDto} attemptReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockTestPerson: async (testId: string, sapNumber: string, attemptReasonDto: AttemptReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('lockTestPerson', 'testId', testId)
            // verify required parameter 'sapNumber' is not null or undefined
            assertParamExists('lockTestPerson', 'sapNumber', sapNumber)
            // verify required parameter 'attemptReasonDto' is not null or undefined
            assertParamExists('lockTestPerson', 'attemptReasonDto', attemptReasonDto)
            const localVarPath = `/api/v1/tests/{testId}/people/{sapNumber}/lock`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)))
                .replace(`{${"sapNumber"}}`, encodeURIComponent(String(sapNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attemptReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The lock stays in the history, with who lifted it and when.
         * @summary Lift the lock on the person\'s attempts at the test
         * @param {string} testId 
         * @param {string} sapNumber The person, by the SAP number.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockTestPerson: async (testId: string, sapNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('unlockTestPerson', 'testId', testId)
            // verify required parameter 'sapNumber' is not null or undefined
            assertParamExists('unlockTestPerson', 'sapNumber', sapNumber)
            const localVarPath = `/api/v1/tests/{testId}/people/{sapNumber}/lock`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)))
                .replace(`{${"sapNumber"}}`, encodeURIComponent(String(sapNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestPeopleApi - functional programming interface
 * @export
 */
export const TestPeopleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestPeopleApiAxiosParamCreator(configuration)
    return {
        /**
         * How many attempts count and how many were invalidated, the limit with the attempts granted on top of it, what is left, a pass, and a lock — what decides whether the next attempt starts. Known by the SAP number alone: the person need not have taken the test.
         * @summary Where a person stands with a test
         * @param {string} testId 
         * @param {string} sapNumber The person, by the SAP number.
         * @param {string} [positionCode] The position the person would take the test for; the limit follows it. Absent for the test\&#39;s own limit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestPerson(testId: string, sapNumber: string, positionCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttemptStandingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestPerson(testId, sapNumber, positionCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestPeopleApi.getTestPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Always with a reason. Each grant raises the person\'s limit at the test by one; it does not lift a lock, nor the rule of a test that takes no attempt after a pass. Granted by an administrator for now; who else may, comes with permissions.
         * @summary Grant the person one attempt more than the limit
         * @param {string} testId 
         * @param {string} sapNumber The person, by the SAP number.
         * @param {AttemptReasonDto} attemptReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantAttempt(testId: string, sapNumber: string, attemptReasonDto: AttemptReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttemptGrantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantAttempt(testId, sapNumber, attemptReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestPeopleApi.grantAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * With a reason. While the lock is in force no attempt of the person at the test starts; an attempt already running goes on — invalidating ends it.
         * @summary Lock the person\'s attempts at the test
         * @param {string} testId 
         * @param {string} sapNumber The person, by the SAP number.
         * @param {AttemptReasonDto} attemptReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockTestPerson(testId: string, sapNumber: string, attemptReasonDto: AttemptReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttemptLockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lockTestPerson(testId, sapNumber, attemptReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestPeopleApi.lockTestPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The lock stays in the history, with who lifted it and when.
         * @summary Lift the lock on the person\'s attempts at the test
         * @param {string} testId 
         * @param {string} sapNumber The person, by the SAP number.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlockTestPerson(testId: string, sapNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlockTestPerson(testId, sapNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestPeopleApi.unlockTestPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestPeopleApi - factory interface
 * @export
 */
export const TestPeopleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestPeopleApiFp(configuration)
    return {
        /**
         * How many attempts count and how many were invalidated, the limit with the attempts granted on top of it, what is left, a pass, and a lock — what decides whether the next attempt starts. Known by the SAP number alone: the person need not have taken the test.
         * @summary Where a person stands with a test
         * @param {string} testId 
         * @param {string} sapNumber The person, by the SAP number.
         * @param {string} [positionCode] The position the person would take the test for; the limit follows it. Absent for the test\&#39;s own limit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestPerson(testId: string, sapNumber: string, positionCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<AttemptStandingDto> {
            return localVarFp.getTestPerson(testId, sapNumber, positionCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Always with a reason. Each grant raises the person\'s limit at the test by one; it does not lift a lock, nor the rule of a test that takes no attempt after a pass. Granted by an administrator for now; who else may, comes with permissions.
         * @summary Grant the person one attempt more than the limit
         * @param {string} testId 
         * @param {string} sapNumber The person, by the SAP number.
         * @param {AttemptReasonDto} attemptReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantAttempt(testId: string, sapNumber: string, attemptReasonDto: AttemptReasonDto, options?: RawAxiosRequestConfig): AxiosPromise<AttemptGrantDto> {
            return localVarFp.grantAttempt(testId, sapNumber, attemptReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * With a reason. While the lock is in force no attempt of the person at the test starts; an attempt already running goes on — invalidating ends it.
         * @summary Lock the person\'s attempts at the test
         * @param {string} testId 
         * @param {string} sapNumber The person, by the SAP number.
         * @param {AttemptReasonDto} attemptReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockTestPerson(testId: string, sapNumber: string, attemptReasonDto: AttemptReasonDto, options?: RawAxiosRequestConfig): AxiosPromise<AttemptLockDto> {
            return localVarFp.lockTestPerson(testId, sapNumber, attemptReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * The lock stays in the history, with who lifted it and when.
         * @summary Lift the lock on the person\'s attempts at the test
         * @param {string} testId 
         * @param {string} sapNumber The person, by the SAP number.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockTestPerson(testId: string, sapNumber: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unlockTestPerson(testId, sapNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestPeopleApi - interface
 * @export
 * @interface TestPeopleApi
 */
export interface TestPeopleApiInterface {
    /**
     * How many attempts count and how many were invalidated, the limit with the attempts granted on top of it, what is left, a pass, and a lock — what decides whether the next attempt starts. Known by the SAP number alone: the person need not have taken the test.
     * @summary Where a person stands with a test
     * @param {string} testId 
     * @param {string} sapNumber The person, by the SAP number.
     * @param {string} [positionCode] The position the person would take the test for; the limit follows it. Absent for the test\&#39;s own limit.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPeopleApiInterface
     */
    getTestPerson(testId: string, sapNumber: string, positionCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<AttemptStandingDto>;

    /**
     * Always with a reason. Each grant raises the person\'s limit at the test by one; it does not lift a lock, nor the rule of a test that takes no attempt after a pass. Granted by an administrator for now; who else may, comes with permissions.
     * @summary Grant the person one attempt more than the limit
     * @param {string} testId 
     * @param {string} sapNumber The person, by the SAP number.
     * @param {AttemptReasonDto} attemptReasonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPeopleApiInterface
     */
    grantAttempt(testId: string, sapNumber: string, attemptReasonDto: AttemptReasonDto, options?: RawAxiosRequestConfig): AxiosPromise<AttemptGrantDto>;

    /**
     * With a reason. While the lock is in force no attempt of the person at the test starts; an attempt already running goes on — invalidating ends it.
     * @summary Lock the person\'s attempts at the test
     * @param {string} testId 
     * @param {string} sapNumber The person, by the SAP number.
     * @param {AttemptReasonDto} attemptReasonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPeopleApiInterface
     */
    lockTestPerson(testId: string, sapNumber: string, attemptReasonDto: AttemptReasonDto, options?: RawAxiosRequestConfig): AxiosPromise<AttemptLockDto>;

    /**
     * The lock stays in the history, with who lifted it and when.
     * @summary Lift the lock on the person\'s attempts at the test
     * @param {string} testId 
     * @param {string} sapNumber The person, by the SAP number.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPeopleApiInterface
     */
    unlockTestPerson(testId: string, sapNumber: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * TestPeopleApi - object-oriented interface
 * @export
 * @class TestPeopleApi
 * @extends {BaseAPI}
 */
export class TestPeopleApi extends BaseAPI implements TestPeopleApiInterface {
    /**
     * How many attempts count and how many were invalidated, the limit with the attempts granted on top of it, what is left, a pass, and a lock — what decides whether the next attempt starts. Known by the SAP number alone: the person need not have taken the test.
     * @summary Where a person stands with a test
     * @param {string} testId 
     * @param {string} sapNumber The person, by the SAP number.
     * @param {string} [positionCode] The position the person would take the test for; the limit follows it. Absent for the test\&#39;s own limit.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPeopleApi
     */
    public getTestPerson(testId: string, sapNumber: string, positionCode?: string, options?: RawAxiosRequestConfig) {
        return TestPeopleApiFp(this.configuration).getTestPerson(testId, sapNumber, positionCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Always with a reason. Each grant raises the person\'s limit at the test by one; it does not lift a lock, nor the rule of a test that takes no attempt after a pass. Granted by an administrator for now; who else may, comes with permissions.
     * @summary Grant the person one attempt more than the limit
     * @param {string} testId 
     * @param {string} sapNumber The person, by the SAP number.
     * @param {AttemptReasonDto} attemptReasonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPeopleApi
     */
    public grantAttempt(testId: string, sapNumber: string, attemptReasonDto: AttemptReasonDto, options?: RawAxiosRequestConfig) {
        return TestPeopleApiFp(this.configuration).grantAttempt(testId, sapNumber, attemptReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * With a reason. While the lock is in force no attempt of the person at the test starts; an attempt already running goes on — invalidating ends it.
     * @summary Lock the person\'s attempts at the test
     * @param {string} testId 
     * @param {string} sapNumber The person, by the SAP number.
     * @param {AttemptReasonDto} attemptReasonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPeopleApi
     */
    public lockTestPerson(testId: string, sapNumber: string, attemptReasonDto: AttemptReasonDto, options?: RawAxiosRequestConfig) {
        return TestPeopleApiFp(this.configuration).lockTestPerson(testId, sapNumber, attemptReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The lock stays in the history, with who lifted it and when.
     * @summary Lift the lock on the person\'s attempts at the test
     * @param {string} testId 
     * @param {string} sapNumber The person, by the SAP number.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestPeopleApi
     */
    public unlockTestPerson(testId: string, sapNumber: string, options?: RawAxiosRequestConfig) {
        return TestPeopleApiFp(this.configuration).unlockTestPerson(testId, sapNumber, options).then((request) => request(this.axios, this.basePath));
    }
}

